import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const ClusterStyle = styled.div `
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.width};
  height: ${props => props.height};
  border-radius: 50%;
  border: 1px solid ${props => props.fillColor};
  background-color: ${props => props.fillColor};
  font-family: ${props => props.fontFamily};
  color: white;
  font-weight: 500;
  font-size: ${props => props.fontSize};
`;
const GenerateCluster = ({ id, fillColor, width = '40px', height = '40px', count, theme }) => {
    return (_jsx(ClusterStyle, Object.assign({ className: id, width: width, height: height, fillColor: fillColor !== null && fillColor !== void 0 ? fillColor : theme.colors.mainColor, fontFamily: theme.fonts.fontFamily, fontSize: theme.fonts.article }, { children: count })));
};
export default GenerateCluster;
